import EfCardCartLists from './EFCardCartLists';
import EfSpec from '@elem/ui/ef-spec';
import { useState, useEffect } from 'react';
import styles from './index.module.scss';
import EfInfoSection from '@elem/ui/ef-info-section';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';

export default function TheComp({ callbackCart, bundles }: any) {
    const { t } = useLang('delta3series');
    const { locale } = useRouter();

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-m" />
            <EfInfoSection title={t('P_title')} desc={t('P_desc')} />
            <EfCardCartLists items={bundles} callbackCart={callbackCart} list_name={t('P_title')} />
            <EfSpec className="spec-x" />
        </div>
    );
}
